import { TreeNode } from "@/types/tree";
import { getSingularitySectionLibrary } from "./library-singleton";
import { uiStore } from "@/store/store";
import { pasteElements } from "../design-library/design-library";
import { addOrUpdateGeneratedElementDependenciesInlineCSSInCanvasHead } from "../canvas/assets/css-in-head";
import { getBuilderCanvasDocument } from "../canvas/helpers";

const SCREENSHOT_PATH = 'https://breakdance-design-library-section-screenshots-ap-production.up.railway.app/screenshots/barebones/';

export function getSectionsByType(sectionType: string): SectionCardData[] {
  const sectionLibrary = getSingularitySectionLibrary();
  if (!sectionLibrary[sectionType]) return [];
  return sectionLibrary[sectionType].map((section, i) => {
    return {
      label: `${sectionType} ${i}`,
      index: i,
      node: section,
      type: sectionType,
      screenshotUrl: getScreenshotUrlForSection(sectionType, String(section.id))
    };
  });
}

export function getAllSections(): SectionCardData[] {
  const sectionLibrary = getSingularitySectionLibrary();
  return Object.entries(sectionLibrary).flatMap(([sectionType, sections]) => {
    return sections.map((section, i) => {
      return {
        label: `${sectionType} ${i}`,
        index: i,
        node: section,
        type: sectionType,
        screenshotUrl: getScreenshotUrlForSection(sectionType, String(section.id))
      };
    });
  });
}

export function insertSectionAfterNode(
  section: TreeNode,
  afterNode: TreeNode["id"]
): TreeNode["id"] | null {
  uiStore.activateElement(afterNode);

  const pointerForCreatedNodeId: { nodeId?: TreeNode["id"] } = {
    nodeId: undefined
  };

  pasteElements([section], "inserting", pointerForCreatedNodeId);

  return pointerForCreatedNodeId.nodeId ?? null;
}

export function temporarilyHideSectionOnCanvas(nodeId: TreeNode["id"]) {
  addOrUpdateGeneratedElementDependenciesInlineCSSInCanvasHead(
    getBuilderCanvasDocument(),
    `section-add-or-swap-panel-temporary-canvas-styles`,
    `
    [data-node-id="${nodeId}"] {
      display: none !important;
    }
    `
  );
}

export function unhideTemporarilyHiddenSection() {
  addOrUpdateGeneratedElementDependenciesInlineCSSInCanvasHead(
    getBuilderCanvasDocument(),
    `section-add-or-swap-panel-temporary-canvas-styles`,
    ``
  );
}

export type SectionCardData = {
  label: string;
  index: number;
  node: TreeNode;
  type: string;
  screenshotUrl: string;
};

function getScreenshotUrlForSection(
  pageSlug: string,
  sectionId: string
): string {
  const cleanPageSlug = pageSlug.toLowerCase().replace(/[^a-z0-9]/g, "");
  const filename = `${cleanPageSlug}-${sectionId}.jpg`;
  return `${SCREENSHOT_PATH}/${cleanPageSlug}/${filename}`;
}
